import styled from 'styled-components'
import { breakpoint, spacing } from 'helpers'
import { IHeader } from '.'

export const StyledHeader = styled.div<IHeader>`
  background: ${({ theme, color }) => (color === 'error' ? theme.error : theme.low_dark)};
  padding: ${spacing(4)};
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;

  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  h1,
  h2,
  h3 {
    width: 50%;
    padding: 0 ${spacing(2)};
  }

  @media (max-width: ${breakpoint('sm')}) {
    flex-direction: column;

    h1,
    h2,
    h3 {
      width: 100%;
      padding: 0;
    }
    svg {
      width: 50%;
    }
  }
`
